import { RxCoverageApplicationState } from "../RxCoverageApplication";
import { CreditCard } from "../../../Models/payment.model";
import { normalizeYear } from "../../../../../Helpers/normalizers";
import { tokenizerErrors } from "Features/CoverageApplication/Components/CheckoutPage/PaymentInformation/useMicroform";

export const getIsCheckingCreditCard = (state: RxCoverageApplicationState) =>
  state.applicationForm["payment.token"].value === "pending";

export const getCreditCardCheckError = (state: RxCoverageApplicationState) =>
  Object.values(tokenizerErrors).includes(
    state.applicationForm["payment.token"].value as string,
  );

export const getNormalizedCreditCard = (state: RxCoverageApplicationState) => {
  const { expiryDate } = state.applicationForm["payment.billing.creditCard"]
    .value as CreditCard;
  const [month, year] = expiryDate.split("/");
  const fourDigitYear = year ? normalizeYear(year) : "";
  const creditCard = {
    cardExpirationMonth: month,
    cardExpirationYear: fourDigitYear,
  };

  return creditCard;
};
